import { usePostCloseFeature } from "@/hooks/features/usePostCloseFeature"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import React from "react"
import { useQuery } from "@tanstack/react-query"
import { H4 } from "@/components/standard/BFText"
import { View } from "react-native"
import { BFLink } from "@/components/buttons/Links"
import { DrawsSummary } from "@/screens/draws/components/DrawsSummary"

export function RehabBudgetDetails({ loanId }: { loanId: string }) {
  const { isLoading, postCloseFeatureEnabled } = usePostCloseFeature(loanId)
  const loanDetailsQuery = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return data?.postClose?.drawsBudget
    },
  })

  if (!postCloseFeatureEnabled || !loanDetailsQuery.data || isLoading) {
    return null
  }

  const drawsBudget = loanDetailsQuery.data

  return (
    <Vertical className="w-full grow">
      <View className="flex-row items-center justify-between my-2">
        <H4 className="text-midnight-blue">Rehab Budget</H4>
        <BFLink
          testId={"manage-in-trustpoint"}
          size={"sm"}
          text={"Manage in Trustpoint"}
          url={drawsBudget.trustpointBudgetUrl || "cnn.com"}
          showsIcon={true}
        />
      </View>

      <View className="flex flex-col border border-light-grey rounded p-4 py-2 bg-card">
        <Vertical className="py-5 gap-2">
          <DrawsSummary
            budgetedLeft={drawsBudget.budgetedLeft!}
            budgetedTotal={drawsBudget.budgetedTotal!}
            completedDrawsTotal={drawsBudget.completedDrawsTotal!}
            pendingDrawsTotal={drawsBudget.pendingDrawsTotal!}
          />
          <Horizontal
            className={"items-center w-full gap-1 justify-center mt-5"}
          >
            <BFLink
              testId={"rehab-details"}
              size={"md"}
              text={"View Budget Details"}
              path={"./draws"}
            />
          </Horizontal>
        </Vertical>
      </View>
    </Vertical>
  )
}
